import { render, staticRenderFns } from "./NewPersonalOpening.vue?vue&type=template&id=57051ca9&scoped=true&"
import script from "./NewPersonalOpening.vue?vue&type=script&lang=ts&"
export * from "./NewPersonalOpening.vue?vue&type=script&lang=ts&"
import style0 from "./NewPersonalOpening.vue?vue&type=style&index=0&id=57051ca9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57051ca9",
  null
  
)

export default component.exports